// src/data/contact-data.ts
import type { Bilingual } from "@/types/home";

export interface Office {
  city: Bilingual;
  address: Bilingual;
  phone: string;
}

export const OFFICES: Office[] = [
  { city: { ar: "المنصورة (المقر الرئيسي)", en: "Mansoura (HQ)" }, address: { ar: "شارع جيهان، برج الباجوري، المنصورة", en: "Gihan St, El-Bagoury Tower, Mansoura" }, phone: "+20 100 000 0000" },
  { city: { ar: "القاهرة الجديدة", en: "New Cairo" }, address: { ar: "التجمع الخامس، شارع التسعين الشمالي", en: "Fifth Settlement, North 90th St" }, phone: "+20 100 000 0001" },
];

/** Mansoura headquarters — used by the interactive map + pin. */
export const HQ_MAP = {
  label: { ar: "المقر الرئيسي", en: "Headquarters" } as Bilingual,
  city: { ar: "المنصورة، الدقهلية", en: "Mansoura, Dakahlia" } as Bilingual,
  address: { ar: "شارع جيهان، برج الباجوري", en: "Gihan St, El-Bagoury Tower" } as Bilingual,
  hours: { ar: "الأحد – الخميس، ٩ص – ٥م", en: "Sun – Thu, 9AM – 5PM" } as Bilingual,
  lat: 31.0409,
  lng: 31.3785,
  embed: "https://www.google.com/maps?q=31.0409,31.3785&z=15&hl=en&output=embed",
  link: "https://www.google.com/maps/search/?api=1&query=31.0409,31.3785",
};

export const CONTACT_REASONS: Bilingual[] = [
  { ar: "استفسار عن مشروع", en: "Project enquiry" },
  { ar: "فرصة استثمارية", en: "Investment opportunity" },
  { ar: "شراكة", en: "Partnership" },
  { ar: "وظائف", en: "Careers" },
  { ar: "أخرى", en: "Other" },
];
